/**
 * Format date strings from proposal summaries into human-friendly form.
 *
 * Handles:
 *  - Single ISO dates: "2026-03-29" → "Sat, Mar 29"
 *  - Date ranges:      "2026-03-25 — 2026-03-26" → "Tue, Mar 25 — Wed, Mar 26"
 *  - Dates with extra info: "2026-03-29 · 9:00 AM — 1:30 PM (7.5 hrs)"
 *                         → "Sat, Mar 29 · 9:00 AM — 1:30 PM (7.5 hrs)"
 *  - Non-date strings are returned as-is
 */

const ISO_DATE_RE = /\d{4}-\d{2}-\d{2}/g;

function formatSingleDate(isoStr) {
  const [year, month, day] = isoStr.split("-").map(Number);
  const d = new Date(year, month - 1, day);
  if (d.getFullYear() !== year || d.getMonth() !== month - 1 || d.getDate() !== day) {
    return isoStr;
  }
  const dayName = d.toLocaleDateString("en-US", { weekday: "short" });
  const monthName = d.toLocaleDateString("en-US", { month: "short" });
  const now = new Date();
  const showYear =
    Math.abs(d.getFullYear() - now.getFullYear()) >= 1 &&
    Math.abs(d - now) > 180 * 24 * 60 * 60 * 1000;
  return showYear
    ? `${dayName}, ${monthName} ${day}, ${d.getFullYear()}`
    : `${dayName}, ${monthName} ${day}`;
}

export default function formatDate(str) {
  if (!str || typeof str !== "string") return str;
  return str.replace(ISO_DATE_RE, (match) => {
    try {
      return formatSingleDate(match);
    } catch {
      return match;
    }
  });
}
